import { lazy } from 'react';

const NavBar = lazy(() => import(/* webpackChunkName: "navbar" */ './navbar'));

export default NavBar;
